import { injectedEditorsSlice } from "./reducer";
import { createServiceBuilder } from "./lib";
const { actions, selectors } = injectedEditorsSlice;
export const EditorsServiceBuilder = createServiceBuilder({
    name: 'EditorsService',
    api: ({ ProjectService }) => {
        const _resolveTab = (state, serializedTab) => {
            const { id, resourceID, viewerID } = serializedTab;
            const resource = resourceID
                ? ProjectService.getResourceByID(state, resourceID)
                : undefined;
            return { id, resource, viewerID };
        };
        return {
            actions,
            selectors,
            _resolveTab,
            getFocusedTab: (state) => {
                const serializedTab = selectors._getFocusedTab(state);
                if (!serializedTab)
                    return undefined;
                return _resolveTab(state, serializedTab);
            },
            getTabs(state) {
                const serialized = selectors._getTabs(state);
                return serialized.map(_resolveTab.bind(null, state));
            },
            open: (request) => (dispatch, getState) => {
                const { resourceID, viewerID } = request;
                const state = getState();
                if (!viewerID && !resourceID) {
                    throw new Error('InvalidRequest: Open in editor must declare either a resourceID or a viewID');
                }
                let editorTab = state.editor.tabs.find((tab) => (tab.resourceID === resourceID && tab.viewerID === viewerID));
                if (!editorTab) {
                    dispatch(actions.createEditorTab(request));
                }
                else {
                    dispatch(actions.focusEditorTab(editorTab.id));
                }
            },
        };
    },
});
//# sourceMappingURL=EditorsService.js.map